import axios from "axios";
import store from "../store";

// Accepte soit une string JSON (ex: éditeur ace_editor), soit directement un objet JS
// (ex: appel programmatique depuis un composant vueComponent personnalisé).
function parse_data(data) {
	if (typeof data == "string")
		return data ? JSON.parse(data) : {};
	return data || {};
}

class Code {

	// test_jwt (optionnel) : jwt d'un utilisateur simulé ("tester en tant que"). L'exécution
	// de code est déjà un test volontaire (identique en risque à un test normal), pas de
	// restriction ici.
	code(code, data, test_jwt = null) {
		return new Promise(function (resolve, reject) {
			let jwt = test_jwt || store.state.jwt;
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/code",
					{
						code,
						data: parse_data(data)
					},
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					console.log(error.response.data)
					resolve(error.response.data);
				});
		});
	}

	// version est optionnel (avant-dernier param, défaut null) : si non fourni,
	// le back utilise la version en production.
	// test_jwt (optionnel, dernier param) : jwt d'un utilisateur simulé ("tester en tant que").
	run_by_name(name, data, version = null, test_jwt = null) {
		return new Promise(function (resolve, reject) {
			let jwt = test_jwt || store.state.jwt;
			var body = {
				name,
				data: parse_data(data)
			};
			if (version)
				body.version = version;
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/code",
					body,
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					console.log(error.response.data)
					resolve(error.response.data);
				});
		});
	}

}

export default new Code();
